import { TAG } from "@/components/tag/types";
import { POSTHOG_FEATURE_FLAG, type PostHogFeatureFlag } from "@/services/feature-flags/posthog-feature-flags";

export type NavLink = {
    url: string;
    name: string;
    translationKey?: string;
    tagVariant?: TAG;
    external?: boolean;
    postHogFeatureFlag?: PostHogFeatureFlag;
};
/**
 *  Decouple from mobile implementation for now. We are updating the desktop view to use icons
 *  but leaving the mobile alone
 * */

// Admins get additional links in the settings menu in addition to the user ones
export const DesktopAdminSettingsNavList = [
    {
        url: "/DeviceDebugger",
        name: "Device Debugger",
    },
    {
        url: "/AccountManager",
        name: "Account Manager",
    },
];

export const DesktopUserSettingsNavList: NavLink[] = [
    {
        url: "/settings",
        name: "Settings",
        translationKey: "settings",
    },
    {
        url: "/export",
        name: "Data Export",
        translationKey: "data-export",
    },
    {
        url: "/thresholdBasedEvents",
        name: "Event Explorer",
        translationKey: "event-explorer",
        tagVariant: TAG.BETA,
        postHogFeatureFlag: POSTHOG_FEATURE_FLAG.THRESHOLD_EVENT_EXPLORER,
    },
];

export const AdminToolsNavList = [
    {
        url: "/DeviceDebugger",
        name: "Device Debugger",
    },
    {
        url: "/AccountManager",
        name: "Account Manager",
    },
    {
        url: "/export",
        name: "Data Export",
    },
];
